import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { userAtom } from "@Recoil/Atom/userAtom"
import { dbDateFormat } from "@Utils/utils"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { Dimensions, StyleSheet, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import { useRecoilValue } from "recoil"

const { width, height } = Dimensions.get("screen")
export const EvaluationCard = (props) => {
    const { backgroundColor, icon, description, callback, startDate, endDate } = props
    const user = useRecoilValue(userAtom)
    const [value, setValue] = useState(0)
    const [loading, setLoading] = useState(false)

    const fetchData = async (userId, starD, endD) => {
        setLoading(true)
        try {
            const response = await callback(userId, starD, endD)
            const data = response.data?.data

            if (data) {
                setValue(data)
            }
            setLoading(false)
        } catch (e) {
            setLoading(false)
        }
    }
    useEffect(() => {
        if (callback && user?.id) {
            fetchData(
                user?.id,
                startDate ? moment(startDate, dbDateFormat).format(dbDateFormat) : startDate,
                endDate ? moment(endDate, dbDateFormat).format(dbDateFormat) : endDate
            )
        } else {
        }
    }, [startDate, endDate])

    return (
        <View
            style={{
                ...styles.container,
                backgroundColor: backgroundColor
            }}
        >
            <View style={{}}>{icon && icon}</View>
            <Spacer height={5} />
            {loading ? (
                <ActivityIndicator style={{ marginTop: 20 }} color={baseColors.white} size={"small"} />
            ) : (
                <View style={{}}>
                    <OpenSansText color={baseColors.white} fontWeight={"bold"} fontSize={40}>
                        {value.toString()}
                    </OpenSansText>
                    <Spacer height={5} />
                    <OpenSansText
                        style={{ paddingRight: 10 }}
                        color={baseColors.white}
                        fontWeight={"bold"}
                        fontSize={16}
                    >
                        {description && description}
                    </OpenSansText>
                </View>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: { padding: 10, borderRadius: 10, width: width / 2.35, height: 168, marginBottom: 15 }
})
